import React from 'react';
import { Modal } from '@mantine/core';
import PrimaryButton from 'components/primaryButton';
import SecondaryButton from 'components/secondaryButton';

import useUpdateProjectData from '../hooks/useUpdateProject';

import { ReactComponent as CrossIcon } from 'assets/icons/crossIcon.svg';
import { ReactComponent as DeactivateProjectsIlls } from 'assets/images/deactivateProjectsIlls.svg';

export default function DeactivateProjectModal({
  isModalOpen,
  setIsModalOpen,
  projectDetails,
}) {
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const updateProjectMutation = useUpdateProjectData(closeModal);

  return (
    <div>
      <Modal
        opened={isModalOpen}
        onClose={() => closeModal(false)}
        title={''}
        withCloseButton={false}
        overlayColor={'#F8F7F799'}
        overlayBlur={20}
        overlayOpacity={0.5}
        centered
        size='lg'
        radius='md'
        overflow='inside'
        transitionDuration={100}
        classNames={{
          title: 'w-full text-333333 font-semibold text-xl text-center',
          modal: 'pl-10',
          body: 'scroller -mr-4 pr-2',
        }}
      >
        {/* button to trap the initial focus */}
        <button className='hidden'></button>
        <CrossIcon
          className='w-10 ml-auto cursor-pointer'
          onClick={() => closeModal()}
        />
        <p className='text-xl text-gray text-center pt-2'>
          Are you sure you want to{' '}
          <span className='font-bold'>
            {projectDetails?.is_active ? 'deactivate' : 'activate'}{' '}
          </span>{' '}
          the <span className='font-bold'>{projectDetails?.title}</span> ?
        </p>
        <DeactivateProjectsIlls className='mx-auto my-10 w-80' />
        <div className='flex space-x-6 justify-center mb-5'>
          <button
            className='w-32'
            onClick={() =>
              updateProjectMutation.mutate({
                id: projectDetails?.id,
                is_active: !projectDetails?.is_active,
              })
            }
          >
            <SecondaryButton isLoading={updateProjectMutation?.isLoading}>
              Yes
            </SecondaryButton>
          </button>
          <button className='w-32' onClick={() => closeModal()}>
            <PrimaryButton>No</PrimaryButton>
          </button>
        </div>
      </Modal>
    </div>
  );
}
